module.exports = __webpack_public_path__ + "static/media/what-matters-most-three.7641127d.png";